import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CloseButtonModule } from '@x/ecommerce-shop/app/core/shop-ui/components/close-button/close-button.module';

@Component({
  selector: 'x-notification',
  standalone: true,
  imports: [CloseButtonModule],
  templateUrl: './notification.component.html',
  styleUrl: './notification.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'x-notification',
  },
})
export class NotificationComponent {}
